<template>
  <MainLayout page-name="fees-for-paid-passengers">
    <PageHeader :title="title">
      <el-row class="header-button">
        <el-col>
          <el-button type="primary" class="calculation" @click="clickCalculation">料金計算</el-button>
        </el-col>
        <el-col>
          <el-button type="primary" class="register" @click="clickRegister">補正登録</el-button>
        </el-col>
        <el-col>
          <el-button type="primary" class="detail-search" @click="clickDetailSearch">詳細検索</el-button>
        </el-col>
      </el-row>
      <SimpleSearch
        :model="simpleSearchFormModel"
        @search="clickSearch"
      >
        <BillingYm v-model="simpleSearchFormModel.billing_ym" :searchCond="true" :initialize="true" mode="search" :required="true"/>
        <BillToCode v-model="simpleSearchFormModel.bill_to_code" :searchCond="true" :autocomplete-list="customerCodeSet" />
        <AirportCode v-model="simpleSearchFormModel.departure_airport_code" label="出発地"
          prop="departure_airport_code" :searchCond="true" :autocomplete-list="airportCodeSet" :initialize="true" />
        <AircraftWeightType v-model="simpleSearchFormModel.aircraft_weight_type" placeholder="機種重量区分" label="" :searchCond="true" :initialize="true" />
      </SimpleSearch>
    </PageHeader>
    <Table
      :table-data="tableData"
      :dataFormatter="csvDataFormatter"
      :default-sort="{ prop: 'bill_to_code', order: 'ascending' }"
      :selectable="deletable"
      @row-click="clickRow"
      @multiple-delete="deleteRows"
    >
      <template #columns>
        <!-- <BillingYmColumn :sortable="true" />
        <BillToCodeColumn label="請求先" :sortable="true" />
        <AirportCodeColumn label="出発地" prop="departure_airport_code" :sortable="true" />
        <SeatsColumn :sortable="true" />
        <PaidPassengersColumn :sortable="true" /> -->
        <!-- <FeeColumn label="旅客数着陸料（税抜き）" prop="passenger_landing_fee_without_tax" :sortable="true" />
        <FeeColumn label="旅客数着陸料（消費税額）" prop="passenger_landing_fee_tax" :sortable="true" /> -->
        <!-- <FeeColumn label="旅客数着陸料（税込）" prop="passenger_landing_fee_with_tax" :sortable="true" :formatter="formatter" />
        <AircraftWeightTypeNameColumn :sortable="true" />
        <RegistTypeColumn :sortable="true" />
        <BlankColumn />
        <MenuColumn @copy="copyRow" :cbdelete="deleteRow" :deletable="deletable" /> -->
        <BillingYmColumn />
        <BillToCodeColumn label="請求先" />
        <AirportCodeColumn label="出発地" prop="departure_airport_code" />
        <SeatsColumn />
        <PaidPassengersColumn />
        <!-- 20220506髙森修正 -->
        <!-- <FeeColumn label="旅客数着陸料（税込）" prop="passenger_landing_fee_with_tax" :formatter="formatter" /> -->
        <FeeColumn label="旅客数着陸料（税抜）" prop="passenger_landing_fee_without_tax" :formatter="formatter" />
        <AircraftWeightTypeNameColumn />
        <RegistTypeColumn />
        <BlankColumn />
        <MenuColumn @copy="copyRow" :cbdelete="deleteRow" :deletable="deletable" />
      </template>
    </Table>
    <FeesForPaidPassengersCalculationDialog
      :visible.sync="calculationDialogVisible"
      @refresh="refreshSearch"
    />
    <FeesForPaidPassengersRegisterDialog
      :visible.sync="registerDialogVisible"
      :current-row="currentRow"
      :autocomplete-airport-code-set="airportCodeSet"
      :autocomplete-customer-code-set="customerCodeSet"
      @refresh="refreshSearch"
    />
    <FeesForPaidPassengersDetailSearchDialog
      :visible.sync="detailDalogVisible"
      :autocomplete-airport-code-set="airportCodeSet"
      :autocomplete-customer-code-set="customerCodeSet"
      :current-row="currentRow"
      @search="detailSearch"
    />
    <FeesForPaidPassengersEditDialog
      :visible.sync="editDialogVisible"
      :autocomplete-airport-code-set="airportCodeSet"
      :autocomplete-customer-code-set="customerCodeSet"
      :current-row="currentRow"
      @refresh="refreshSearch"
    />
  </MainLayout>
</template>

<script>
import MainLayout from '@/components/templates/MainLayout.vue'
import PageHeader from '@/components/organisms/PageHeader.vue'
import BillingYm from '@/components/molecules/form/select/BillingYm.vue'
import BillToCode from '@/components/molecules/form/autocomplete/BillToCode.vue'
import AirportCode from '@/components/molecules/form/autocomplete/AirportCode.vue'
import AircraftWeightType from '@/components/molecules/form/select/AircraftWeightType.vue'
import SimpleSearch from '@/components/organisms/SimpleSearch.vue'
// import Table from '@/components/molecules/table/Table.vue'
import Table from '@/components/molecules/table/TablePaging.vue'
import BillToCodeColumn from '@/components/molecules/table/BillToCodeColumn.vue'
import AirportCodeColumn from '@/components/molecules/table/AirportCodeColumn.vue'
import SeatsColumn from '@/components/molecules/table/SeatsColumn.vue'
import PaidPassengersColumn from '@/components/molecules/table/PaidPassengersColumn.vue'
import FeeColumn from '@/components/molecules/table/FeeColumn.vue'
import AircraftWeightTypeNameColumn from '@/components/molecules/table/AircraftWeightTypeNameColumn.vue'
import RegistTypeColumn from '@/components/molecules/table/RegistTypeColumn.vue'
import BlankColumn from '@/components/molecules/table/BlankColumn.vue'
import MenuColumn from '@/components/molecules/table/MenuColumn.vue'
import FeesForPaidPassengersCalculationDialog from '@/components/pages/calculation/feesForPaidPassengers/FeesForPaidPassengersCalculationDialog.vue'
import FeesForPaidPassengersRegisterDialog from '@/components/pages/calculation/feesForPaidPassengers/FeesForPaidPassengersRegisterDialog.vue'
import FeesForPaidPassengersDetailSearchDialog from '@/components/pages/calculation/feesForPaidPassengers/FeesForPaidPassengersDetailSearchDialog.vue'
import FeesForPaidPassengersEditDialog from '@/components/pages/calculation/feesForPaidPassengers/FeesForPaidPassengersEditDialog.vue'
import AirportAutocompleteLoader from '@/mixins/AirportAutocompleteLoader.vue'
import CustomerAutocompleteLoader from '@/mixins/CustomerAutocompleteLoader.vue'

export default {
  components: {
    MainLayout,
    PageHeader,
    BillingYm,
    BillToCode,
    AirportCode,
    AircraftWeightType,
    SimpleSearch,
    Table,
    BillToCodeColumn,
    AirportCodeColumn,
    SeatsColumn,
    PaidPassengersColumn,
    FeeColumn,
    AircraftWeightTypeNameColumn,
    RegistTypeColumn,
    BlankColumn,
    MenuColumn,
    FeesForPaidPassengersCalculationDialog,
    FeesForPaidPassengersRegisterDialog,
    FeesForPaidPassengersDetailSearchDialog,
    FeesForPaidPassengersEditDialog
  },
  mixins: [
    AirportAutocompleteLoader,
    CustomerAutocompleteLoader
  ],
  data () {
    return {
      title: '着陸料[有償旅客]',
      tableData: [],
      simpleSearchFormModel: {
        billing_ym: this.getDefaultBillingYm(),
        bill_to_code: '',
        departure_airport_code: '',
        aircraft_weight_type: ''
      },
      currentRow: {},
      calculationDialogVisible: false,
      registerDialogVisible: false,
      detailDalogVisible: false,
      editDialogVisible: false
    }
  },
  computed: {
  },
  mounted () {
    sessionStorage.removeItem('feesForPaidPassengersSearchCond')
    this.loadAirport()
    this.loadCustomer()
  },
  methods: {
    clickCalculation () {
      this.calculationDialogVisible = true
    },
    clickRegister () {
      this.currentRow = {}
      this.registerDialogVisible = true
    },
    clickDetailSearch () {
      this.detailDalogVisible = true
    },
    clickSearch () {
      sessionStorage.setItem('feesForPaidPassengersSearchCond', JSON.stringify(this.simpleSearchFormModel))
      this.search()
    },
    detailSearch () {
      const searchCond = JSON.parse(sessionStorage.getItem('feesForPaidPassengersSearchCond'))
      Object.keys(this.simpleSearchFormModel).forEach((x) => { this.$set(this.simpleSearchFormModel, x, searchCond[x]) })
      this.search()
    },
    search () {
      this.$loadingMask.on()
      const searchCond = JSON.parse(sessionStorage.getItem('feesForPaidPassengersSearchCond'))
      this.$axios
        .get('/search-fees-for-paid-passengers', { params: searchCond })
        .then((res) => {
          this.tableData = res.data.list
          for (var i = 0; i <= this.tableData.length - 1; i += 1) {
            // this.tableData[i].selected = false
            this.$set(this.tableData[i], 'selected', false)
          }
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          this.$loadingMask.off()
        })
    },
    refreshSearch (billingYm) {
      const searchCond = JSON.parse(sessionStorage.getItem('feesForPaidPassengersSearchCond'))
      if (!searchCond) {
        this.$set(this.simpleSearchFormModel, 'billing_ym', billingYm)
        sessionStorage.setItem('feesForPaidPassengersSearchCond', JSON.stringify(this.simpleSearchFormModel))
      }

      this.search()
    },
    csvDataFormatter (row) {
      const result = { ...row }
      delete result.update_on
      result.start_date += ' 00:00:00'
      result.end_date += ' 00:00:00'
      return result
    },
    // clickRow (row, column, event) {
    //   this.currentRow = row
    //   this.editDialogVisible = true
    // },
    clickRow (row, table) {
      this.currentRow = row
      this.editDialogVisible = true
      this.tableData = table
    },
    copyRow (row) {
      const currentRow = { ...row }
      if (parseInt(row.billing_ym) < parseInt(this.getDefaultBillingYm())) {
        currentRow.billing_ym = ''
      }
      this.currentRow = currentRow
      this.registerDialogVisible = true
    },
    deletable (row, index) {
      // 削除可能条件
      return !(parseInt(row.billing_ym) < parseInt(this.getDefaultBillingYm()) || row.regist_type === '1')
    },
    deleteRow (row) {
      this.deleteRows([row])
    },
    async deleteRows (rows) {
      if (!(await this.$fcMessage.messageBox(this.title, 'CMN0003W'))) {
        return
      }

      this.$loadingMask.on()
      await this.$axios
        .delete('/fees-for-paid-passengers', { data: rows })
        .then((res) => {
          this.$fcMessage.showMessage(res.data.message)
          this.search()
        })
        .catch((e) => {
          this.$loadingMask.off()
          if (e.response) {
            switch (e.response.status) {
              case 402:
                this.$fcMessage.showMessage(e.response.data.message, true)
                break
              default:
            }
          }
        })
    },
    formatter (row, column) {
      // 20220509髙森修正
      // if (row.passenger_landing_fee_with_tax !== null) {
      if (row.passenger_landing_fee_without_tax !== null) {
        // return String(row.passenger_landing_fee_with_tax).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
        return String(row.passenger_landing_fee_without_tax).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      } else {
        return '-'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header-button {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  margin-bottom: 2rem;
  ::v-deep .el-col {
    width: auto;
    margin-left: 2rem;
    .el-button {
      font-size: inherit;
      width: 20rem;
    }
  }
}
.dummy {
  display: none;
}
th.billing-ym{
  display: none;
}
td.billing-ym{
  display: none;
}
</style>
